import { getNextPage } from '@/modules/FileList/utils/getNextPage';
import { infiniteQueryOptions } from '@tanstack/react-query';
import { WalletPeriodUnsettledQueryParamsType } from './walletPeriodUnsettledQuery.type';
import { walletPeriodUnsettledFunction } from './walletPeriodUnsettledQueryFunction';

export const walletPeriodUnsettledQueryOptions = (
  params: Omit<WalletPeriodUnsettledQueryParamsType, 'page'>,
) => {
  return infiniteQueryOptions({
    queryKey: ['wallet-period-unsettled', params],
    queryFn: ({ pageParam }) =>
      walletPeriodUnsettledFunction({ ...params, page: pageParam }),
    initialPageParam: 1,
    getNextPageParam: getNextPage,
  });
};
